import CircularProgress from "@mui/material/CircularProgress";

// Single loading indicator replacing the copy-pasted ThreeDots markup that
// used to live in ~18 files (react-loader-spinner dependency removed).
// Callers keep their own positioning wrapper (full-screen overlay, inline, etc).
const Spinner = ({ size = 60 }) => (
  <CircularProgress sx={{ color: "#104581" }} size={size} />
);

export default Spinner;
